// import GridOptions from './GridOptions';
// import { icons } from '../../../../../shared/icons';
import { useTranslation } from 'react-i18next';
import { formatDateFromDB } from '../../../../../../utils/FormatDate';
import MuiGrid from '../../../../UI/MuiGrid/MuiGrid';
import Sifra from '../../../../../../shared/components/Sifra';

const GridProvider = ({ data, handleClickNapomena, isLoading }) => {
  const { t } = useTranslation();
  const columns = [
    // {
    //   field: 'id',
    //   disableExport: true,
    //   headerName: t('options'),
    //   width: 70,
    //   sortable: false,
    //   filterable: false,
    //   renderCell: (e) => (
    //     <GridOptions
    //       handleOpenDialog={() => handleOpenDialog(e.id)}
    //       getEditData={() => getEditData(e.row)}
    //     >
    //       <button className="header-options">{icons.MENU_ICON}</button>
    //     </GridOptions>
    //   ),
    // },
    // ...(localStorage.idFirme === '1'
    //   ? [
    //       {
    //         field: 'nazivKupca',
    //         headerName: t('client'),
    //         width: 250,
    //       },
    //     ]
    //   : []),
    // { field: 'nazivKupca', headerName: t('client'), width: 200 },
    {
      field: 'zaposleni',
      headerName: 'Zaposleni',
      width: 200,
      renderCell: (e) => (
        <Sifra
          displayValue={e.value}
          onClick={() => handleClickNapomena(e.row)}
        />
      ),
    },
    {
      field: 'datumUnosa',
      headerName: t('date'),
      width: 100,
      renderCell: (e) => <span>{formatDateFromDB(e.row.datumUnosa)}</span>,
    },
    { field: 'opisRadova', headerName: 'Opis', width: 800 },
  ];

  return (
    <div style={{ height: '85vh', width: '99%' }}>
      <MuiGrid data={data} columns={columns} loading={isLoading} />
    </div>
  );
};

export default GridProvider;
